module.exports = __webpack_public_path__ + "img/vaultspay-otm.b1567dbc.png";